<template>
  <app-modal name="invoice-form-modal" :title="title" @before-open="beforeOpen" hide-footer @before-close="beforeClose" width="90%">
    <div class="invoice-form-modal-container">
      <div class="row height-73vh">
        <div v-show="isLoading" class="loading-container center">
          <div class="text-center">
            <h5>{{$t('app.loading')}}</h5>
            <i class="fad fa-spinner-third fa-spin"></i>
          </div>
        </div>
        <div v-show="!isLoading" :class="{'col-md-12': !isLoading && !hasInvoiceFile}" class="col-md-6 invoice-form pr-0">
          <invoice-form v-if="formModel"  ref="form" :form-model="formModel"></invoice-form>
        </div>
        <div v-show="!isLoading && hasInvoiceFile"  class="col-md-6 pl-0">
          <div v-show="!isLoading">
            <invoice-xml-viewer  v-show="xmlSrcData" :xml="xmlSrcData"></invoice-xml-viewer>
            <invoice-viewer v-show="pdfSrcData" :hide-form-viewer="true"  :scale="1.4"  :src="pdfSrcData"></invoice-viewer>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6 text-center">
          <button :disabled="isLoading" @click="onClickPrev" class="btn btn-outline-secondary btn-sm">
            <i class="fal fa-chevron-left"></i>
          </button>
          <span> {{currentIndex + 1}} / {{invoiceList.length}}</span>
          <button :disabled="isLoading"  @click="onClickNext" class="btn btn-outline-secondary btn-sm mr-auto">
            <i class="fal fa-chevron-right"></i>
          </button>
        </div>
        <div class="col-6 text-right">
          <button @click="onClickClose" class="btn btn-outline-secondary btn-sm">
            {{this.$t('app.close')}}
          </button>
          <app-btn-submit
            :is-submitting="isLoading"
            :css="'btn btn-primary btn-sm ml-2'"
            :text="this.$t('app.update')"
            @on-click="onClickSave"
          />
        </div>
      </div>
    </div>

  </app-modal>
</template>
<script>

import AppModal from '@/components/app-modal/';
import InvoiceForm from '@/portal-components/invoice/invoice-form';
import InvoiceViewer from '@/portal-components/invoice/invoice-viewer';
import InvoiceProxy from '@/store/proxies/invoice-proxy';
import InvoiceXmlViewer from '@/portal-components/invoice/invoice-xml-viewer';
import { getTags } from '@/utils/tag';
import { mapActions, mapState } from 'vuex';
import { parseInvoiceFile } from '@/utils/invoice';
import AppBtnSubmit from '@/components/app-button/index';

const defaultFormModel = {
  seller_name: '',
  seller_taxcode: '',
  seller_address: '',
  buyer_name: '',
  buyer_taxcode: '',
  buyer_address: '',
  invoice_number: '',
  issued_date: new Date(),
  total_amount_without_tax: '',
  total_amount_with_tax: '',
  kind_of: false,
  id: null,
  parent_id: null,
  file_base64: '',
  tags: [],
};

export default {
  name: 'InvoiceFormModal',
  components: {
    AppBtnSubmit,
    InvoiceForm,
    AppModal,
    InvoiceViewer,
    InvoiceXmlViewer,
  },
  data() {
    return {
      isMobile: false,
      title: this.$t('invoice.updateInvoice'),
      file_name: null,
      formModel: null,
      invoiceFile: null,
      invoiceList: [],
      currentIndex: -1,
      isLoading: false,
    };
  },

  computed: {
    pdfSrcData() {
      const file = parseInvoiceFile(this.invoiceFile);
      return (file && file.type === 'pdf') ? file.content : '';
    },
    xmlSrcData() {
      const file = parseInvoiceFile(this.invoiceFile);
      return (file && file.type === 'xml') ? file.content : '';
    },
    hasInvoiceFile() {
      return !!this.pdfSrcData || !!this.xmlSrcData;
    },
    ...mapState(['currentTagAccessList']),
  },
  methods: {
    ...mapActions(['createInvoice', 'updateInvoice', 'addImportedInvoice', 'removeImportedInvoice', 'removeErrorInvoices']),
    save(payload) {
      const vm = this;
      return new Promise((resolve, reject) => {
        vm.$refs.form.submit();
        vm.$refs.form.validate().then((isValid) => {
          if (isValid) {
            this.isLoading = true;
            payload.id = this.formModel.id;
            payload.tags = getTags(payload.tags);
            const result = vm.updateInvoice(payload);
            result.then(() => {
              resolve(payload);
              setTimeout(() => {
                this.isLoading = false;
              }, 500);
            }).catch((error) => {
              reject(error);
              setTimeout(() => {
                this.isLoading = false;
              }, 500);
            });
          }
        });
      });
    },
    beforeClose() {
      this.formModel = Object.assign({}, defaultFormModel);
      this.$bus.emit('display-invoice-form-model', false);
      this.invoiceFile = null;
    },
    onClickNext() {
      if (this.currentIndex < this.invoiceList.length - 1) {
        this.currentIndex++;
        this.loadFormModel();
        this.$nextTick(() => {
          this.$refs.form.initialize();
        });
      }
    },
    onClickPrev() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.loadFormModel();
        this.$nextTick(() => {
          this.$refs.form.initialize();
        });
      }
    },
    onClickSave() {
      const payload = this.$refs.form.getValues();
      this.save(payload).then((res) => {
        this.$bus.emit('update-invoice-success', { model: res });
      });
    },
    onClickClose() {
      this.$modal.hide('invoice-form-modal', { isOk: true });
    },
    getTaxPercentage() {
      const total = parseInt(this.formModel.total_amount_with_tax, 0);
      const totalBeforeTax = parseInt(this.formModel.total_amount_without_tax, 0);
      const percent = ((total - totalBeforeTax) / totalBeforeTax) * 100;
      return Math.round(percent);
    },
    loadFormModel() {
      this.formModel = Object.assign({}, this.invoiceList[this.currentIndex]);
      this.formModel.tags = this.formModel.tags.map(t => t.id);
      this.formModel.tax_percentage = this.getTaxPercentage();
      // this.file_name = params.file_name;
      delete this.formModel.error;
      delete this.formModel.file_name;
      this.isLoading = true;
      if (this.formModel.file_base64) {
        this.$nextTick(() => {
          this.invoiceFile = this.formModel.file_base64;
        });
      } else {
        const promise = this.currentTagAccessList ? new InvoiceProxy().getSharedInvoiceFile({
          id: this.formModel.id,
          access_list_id: this.currentTagAccessList.id,
          company_owner: this.currentTagAccessList.company_owner,
        }) : new InvoiceProxy().getInvoiceFile(this.formModel.id);
        promise
          .then((res) => {
            this.invoiceFile = res.file_base64;
            this.$nextTick(() => {
              this.formModel.file_base64 = res.file_base64;
            });
          })
          .catch(() => {
            this.$nextTick(() => {
              this.formModel.file_base64 = null;
              this.invoiceFile = null;
            });
          })
          .finally(() => {
            setTimeout(() => {
              this.isLoading = false;
            }, 300);
          });
      }
    },
    beforeOpen(params) {
      this.invoiceList = params.invoiceList;
      this.isMobile = params.isMobile;
      this.currentIndex = params.currentIndex;
      this.loadFormModel();
      this.$bus.emit('display-invoice-form-model', true);
    },
  },
};
</script>
<style lang="scss">
 .height-73vh {
   height: 73vh;
 }
</style>



// WEBPACK FOOTER //
// src/portal-components/invoice/invoice-form-modal.vue